import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client'

// Install the vue plugin
Vue.use(VueApollo)

// Name of the localStorage item
const AUTH_TOKEN = 'apollo-token'

// Http endpoint

//const httpEndpoint = 'https://proxy.khipu.edu.pe/https://academico.khipu.edu.pe/public/graphql';
//const httpEndpoint = 'http://apiacademico.test/graphql'
//const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost/khipu_ist_api/public/graphql'
const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || '/public/graphql'
//const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'https://proxy.khipu.edu.pe/http://academico.khipu.edu.pe/public/graphql'
//const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'https://proxy.khipu.edu.pe/http://academicodev.khipu.edu.pe/public/graphql'
//const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'https://proxy.khipu.edu.pe/http://api.khipu.net/public/graphql'
//const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'https://proxy.khipu.plus/http://api-academico.khipu.edu.pe/public/graphql-playground'
//const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'https://proxy.khipu.edu.pe/http://api.khipu.net/public/graphql'

//const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'https://cors-anywhere.herokuapp.com/http://api-academico.khipu.edu.pe/public/graphql'
//const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'http://api-academico.khipu.edu.pe/public/graphql'
//const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'http://academico.khipu.edu.pe/public/graphql'
//const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'https://proxy.khipu.plus/http://api-academico.khipu.edu.pe/public/graphql'

const httpEndpointAsp = 'https://proxy.khipu.edu.pe/http://apigraphql.khipu.edu.pe/graphql/'

// Config
const defaultOptions = {
  // You can use `https` for secure connection (recommended in production)
  httpEndpoint,
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  //wsEndpoint: process.env.VUE_APP_GRAPHQL_WS || 'ws:localhost:8008/khipu_ist_api_conFruitCake/public/graphql',
  //wsEndpoint: process.env.VUE_APP_GRAPHQL_WS || 'ws:cors-anywhere.herokuapp.com/http://api-academico.khipu.edu.pe/public/graphql',
  //wsEndpoint: process.env.VUE_APP_GRAPHQL_WS || 'ws:api-academico.khipu.edu.pe/public/graphql',
  //wsEndpoint: process.env.VUE_APP_GRAPHQL_WS || 'ws:/public/graphql',
  // LocalStorage token
  tokenName: AUTH_TOKEN,
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,
  //fetchPolicy: 'cache-and-network',
  //fetchPolicy: 'no-cache',
//   watchQuery: {
//     fetchPolicy: 'cache-and-network',
//   },

  // Override default apollo link
  // note: don't override httpLink here, specify httpLink options in the
  // httpLinkOptions property of defaultOptions.
  // link: myLink

  // Override default cache
  // cache: myCache

  // Override the way the Authorization header is set
  // getAuth: (tokenName) => ...

  // Additional ApolloClient options
  // apollo: { ... }

  // Client local data (see apollo-link-state)
  // clientState: { resolvers: { ... }, defaults: { ... } }
}

// Call this in the Vue app file
export function createProvider (options = {}) {
  // Create apollo client

  const createA= createApolloClient({
    ...defaultOptions,
    ...options
  });

  const createB= createApolloClient({
    ...defaultOptions,
    httpEndpoint: httpEndpointAsp
  });


  const academico = createA.apolloClient;
  const aspcore = createB.apolloClient;

  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    clients: {
        academico,
        aspcore
    },
    defaultClient: academico,
    defaultOptions: {
      $query: {
        fetchPolicy: 'cache-and-network',
      },
    },
    errorHandler (error) {
      // eslint-disable-next-line no-console
      console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message)
    },
  })

  return apolloProvider
}

// Manually call this when user log in
export async function onLogin (apolloClient, token) {
  if (typeof localStorage !== 'undefined' && token) {
    localStorage.setItem(AUTH_TOKEN, token)
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    await apolloClient.resetStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (login)', 'color: orange;', e.message)
  }
}

// Manually call this when user log out
export async function onLogout (apolloClient) {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(AUTH_TOKEN)
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    await apolloClient.resetStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (logout)', 'color: orange;', e.message)
  }
}
